import { render, staticRenderFns } from "./me-service-chunk.vue?vue&type=template&id=09b3e7e6&scoped=true"
import script from "./me-service-chunk.vue?vue&type=script&lang=js"
export * from "./me-service-chunk.vue?vue&type=script&lang=js"
import style0 from "./me-service-chunk.vue?vue&type=style&index=0&id=09b3e7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3e7e6",
  null
  
)

export default component.exports